'use strict';

/**
 * error.js contains functions for error handling / displaying
 */

/**
 * Generate a 404 message
 * @param {string} errorTitle
 * @param {string} errorMsg
 */
export function generate404(errorTitle, errorMsg) {
  document.body.removeChild(document.querySelector('.controls'));
  document.body.removeChild(document.querySelector('#flayrMap'));

  document.title = errorTitle + ' - ' + errorMsg;

  let flayrLogo = document.createElement('div');
  flayrLogo.className = 'flayrLogo_404';
  flayrLogo.id = 'flayrLogo_404';
  flayrLogo.innerHTML = '<i class="material-icons" id="flayrLayer">&#xE53B;</i>';

  let error404 = document.createElement('div');
  error404.className = 'error404';
  error404.id = 'error404';
  error404.innerHTML = '<span class="head404">404</span>';

  let errorMessage = document.createElement('div');
  errorMessage.className = 'errorMessage';
  errorMessage.id = 'errorMessage';
  errorMessage.innerHTML = errorMsg;

  error404.append(errorMessage);

  flayrLogo.appendChild(error404);

  document.body.appendChild(flayrLogo);
}
